import colors from "core/resources/theme/colors";
import styled from "styled-components";

export const Container = styled.div<any>`
  .ant-picker-focused:not(.ant-picker-disabled),
  .ant-picker:not(.ant-picker-disabled):hover {
    box-shadow: 0 0 0 2px
      ${(props) => (props.isInvalid ? colors.red : colors.primary)} !important;
    outline-color: ${(props) =>
      props.isInvalid ? colors.red : colors.primary} !important;
  }
`;
